import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { NivisionTab } from '../../../../features/B3/nivision-tab';

const searchSchema = z.object({
  site: z
    .string()
    .regex(/^[A-Za-z0-9_-]{1,64}$/)
    .optional()
    .catch(undefined),
});

/** Client page tab "חיבור NIVISION" (lane B3-web). ?site=<siteId> picks the site of a multi-site client. */
export const Route = createFileRoute('/_app/client/$clientId/nivision')({
  validateSearch: (s: Record<string, unknown>) => searchSchema.parse(s),
  component: NivisionRoute,
});

function NivisionRoute() {
  const { clientId } = Route.useParams();
  const { site } = Route.useSearch();
  const navigate = Route.useNavigate();
  return <NivisionTab clientId={clientId} siteParam={site} onSiteChange={(id) => void navigate({ search: { site: id }, replace: true })} />;
}
